function Browse() {
  return (
    <div style={{ paddingTop: '90px', minHeight: '100vh', padding: '90px 2rem 2rem' }}>
      <h1>Browse</h1>
      <p>This page is under construction.</p>
    </div>
  );
}

export default Browse;

